export default __webpack_public_path__ + "adc7fba1435f5aaed2acd8ad9c72a7ad.webp";